import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './AddToFoldersDropdownContainer';
import { AddToFolderDropdownLoading } from './components/loader/AddToFolderDropdownLoader';
import styles from './add_to_folders_dropdown.module.scss';
import { FoldersDropdownCreate } from './create-folder/FoldersDropdownCreate';
import { FoldersDropdownChoose } from './choose-folder/FoldersDropdownChoose';

type Props = {
  onFolderSelect: Function;
  onFolderCreate: ({
    title,
    source,
  }: {
    title: string;
    source: string;
  }) => void;
  isLoading: boolean;
} & PropsFromRedux;

export const RawAddToFoldersDropdown: FC<Props> = ({
  onFolderSelect,
  onFolderCreate,
  isLoading,
  hasFolders,
}) => {
  if (isLoading) {
    return (
      <div className={styles.container}>
        <AddToFolderDropdownLoading />
      </div>
    );
  }
  return (
    <div className={styles.container} id="folder-drop">
      {!hasFolders ? (
        <FoldersDropdownCreate onFolderCreate={onFolderCreate} />
      ) : (
        <FoldersDropdownChoose
          onFolderSelect={onFolderSelect}
          onFolderCreate={onFolderCreate}
        />
      )}
    </div>
  );
};

export const AddToFoldersDropdown = Connect(RawAddToFoldersDropdown);
